export default __webpack_public_path__ + "static/media/sub-category-wellness-LocationShoot.bf134ede.jpg";